import { WifiOff, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

// Shown when a saved login can't be checked (no signal / server busy). The login is kept.
export const ConnectionRetry = ({ onRetry, onSignOut }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="connection-retry">
    <div className="max-w-sm w-full text-center">
      <span className="mx-auto w-14 h-14 rounded-2xl bg-muted grid place-items-center"><WifiOff className="w-6 h-6 text-muted-foreground" /></span>
      <h1 className="font-display text-2xl font-bold mt-5">Can&apos;t reach Cross Jobs</h1>
      <p className="text-sm text-muted-foreground mt-2">You&apos;re still signed in. Check your signal and try again. We&apos;ll also retry when you&apos;re back online.</p>
      <Button onClick={onRetry} className="mt-6 w-full rounded-full bg-primary hover:bg-primary/90 text-white h-11" data-testid="connection-retry-btn">
        <RotateCw className="w-4 h-4 mr-2" /> Try again
      </Button>
      <button type="button" onClick={onSignOut} className="mt-4 text-xs text-muted-foreground hover:underline" data-testid="connection-signout-btn">Sign out instead</button>
    </div>
  </div>
);
